/**
 * @generated SignedSource<<453984ce40c6355c64ee3caebe43134c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type utility_GetCurrentUserQuery$variables = Record<PropertyKey, never>;
export type utility_GetCurrentUserQuery$data = {
  readonly currentUser: {
    readonly configuration: {
      readonly frontendBuildId: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type utility_GetCurrentUserQuery = {
  response: utility_GetCurrentUserQuery$data;
  variables: utility_GetCurrentUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Configuration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "frontendBuildId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "utility_GetCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "utility_GetCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "62dd57681942e69a8be860ab33fd03ad",
    "id": null,
    "metadata": {},
    "name": "utility_GetCurrentUserQuery",
    "operationKind": "query",
    "text": "query utility_GetCurrentUserQuery {\n  currentUser {\n    configuration {\n      frontendBuildId\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "20c9a42c55b1a0db458b397675e6eba2";

export default node;
